import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Card, CardBody } from 'reactstrap'

import { getBuckets } from 'slices/csvUploaderSlice'
import { showSuccess } from 'slices/notificationSlice'

import { NavMenu, CustomButton } from 'components/common'

import { CsvAutoRecordsUploadDialog } from './CsvAutoRecordsUploadDialog'

export const CsvAutoRecordsUpload = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getBuckets())
  }, [dispatch])

  return (
    <NavMenu>
      <>
        <div className="m-3">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <div className="d-flex align-items-center">
              <div className="font-x-large fw-bold">作業実績</div>
            </div>
            <div className="d-flex  ms-auto">
              <CustomButton className="me-2" outline onClick={() => setIsDialogOpen(true)}>
                作業実績アップロード
              </CustomButton>
            </div>
          </div>
          <Card className="mt-2">
            <CardBody className="p-4">
              <div className="mb-3">
                作業実績を一括でアップロードできる機能です。右上の「作業実績アップロード」よりおこなってください。
              </div>

              <div className="my-3">
                <div className="my-2 fw-bold font-middle">注意事項</div>
                <ul className="mb-3">
                  <li>この処理は高度な処理です。十分にご注意の上、操作してください。</li>
                  <li>対象の作業は実績入力方法が「自動アップロード」の作業のみです。</li>
                  <li>アップロードするためには事前に設定が必要になります。ご希望の方は担当者までご連絡ください。</li>
                </ul>
              </div>

              <div className="mt-3">
                <div className="my-2 fw-bold font-middle">データに関する注意事項</div>
                <ul className="mb-3">
                  <li>対応している文字コードはSHIFT-JISのみです。</li>
                  <li>
                    データフォーマットは、選択したアップロード先名称に、CSVアップローダで取り込んでいるものと同様のデータフォーマットのみ受け付けます。
                    異なるデータフォーマットのファイルのアップロードはできません。ご不明な場合は担当者までご連絡ください。
                  </li>
                  <li>当日を除く45営業日前までのアップロードが可能です。それより以前のデータは反映されません。</li>
                </ul>
              </div>
            </CardBody>
          </Card>
        </div>
        <CsvAutoRecordsUploadDialog
          isOpen={isDialogOpen}
          onSuccess={() => {
            setIsDialogOpen(false)
            dispatch(
              showSuccess({
                successMessage: '作業実績のアップロードに成功しました。反映までしばらく時間がかかる場合があります。',
              })
            )
          }}
          onCancel={() => setIsDialogOpen(false)}
        />
      </>
    </NavMenu>
  )
}
